import PropTypes from 'prop-types';
import React  from 'react';
import { connect } from 'react-redux';

import Fab from '@material-ui/core/Fab';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Edit from '@material-ui/icons/Edit';

import { openLeftBarModule } from '../../modules/actions/layout';


const BusRow = ({ bus, openLeftBarModule }) => (
  <TableRow>
    <TableCell>{bus.attributes['vehicle-number']}</TableCell>
    <TableCell>{bus.attributes['license-plate']}</TableCell>
    <TableCell>{bus.attributes.seats}</TableCell>
    <TableCell>{bus.attributes['standing-places']}</TableCell>
    <TableCell>{bus.attributes.euronorm}</TableCell>
    <TableCell>
      <div onClick={() => openLeftBarModule('bus', 'busEdit', { id: bus.id })}>
        <Fab color="primary" aria-label="edit" size="small">
          <Edit />
        </Fab>
      </div>
    </TableCell>
  </TableRow>
);

BusRow.propTypes = {
  // own props
  bus: PropTypes.shape({
    id: PropTypes.string.isRequired,

    attributes: PropTypes.shape({
      euronorm: PropTypes.string.isRequired,
      'license-plate': PropTypes.string.isRequired,
      seats: PropTypes.number.isRequired,
      'standing-places': PropTypes.number.isRequired,
      'vehicle-number': PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,

  // dispatch props
  openLeftBarModule: PropTypes.func.isRequired,
};

export default connect(null, { openLeftBarModule })(BusRow);
